<template>
  <b-container>
    <b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>
    <b-alert variant="danger" :show="loginAlert.tip == 1">{{loginAlert.msg}}</b-alert>
    <b-card
      header="共享航次计划信息管理系统"
      header-tag="header"
      align="center"
      header-class="login-header"
      class="form-background"
    >
      <b-row no-gutters style="padding:20px;">
        <div class="form-style">
          <h3 style="font-weight: bold">登录</h3>

          <b-form @submit="onSubmit">
            <b-form-group style="margin:30px 0 40px 0; " id="fieldset-1" label="您的用户名（非真实姓名）" label-for="input-1">
              <b-form-input id="input-1" v-model="form.username" required trim type="text"></b-form-input>
            </b-form-group>

            <b-form-group style="margin-bottom:16px;" id="fieldset-2" label="密码" label-for="input-2">
              <b-form-input id="input-2" v-model="form.password" required trim type="password"></b-form-input>
            </b-form-group>

            <b-row
              style="display:flex;justify-content:space-between; padding:0 20px; font-size:16px;margin-bottom:40px;"
            >
              <div>
                <a href="/findPwd">找回密码/账号</a>
              </div>
              <div>
                没有账号？
                <a href="/register">去注册</a>
              </div>
            </b-row>

            <b-button
              fluid
              block
              :disabled="loading"
              type="submit"
              variant="primary"
              style="padding:6px 80px; background-color:#0582bb;border:1px solid #006ea7"
            >
              <b-spinner small style="margin-right:20px" v-if="loading"></b-spinner>登录
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
    <!-- LINKS -->
    <link-component class="mt20"></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import Vue from 'vue';

export default {
  components: { LinkComponent },
  name: 'option',
  props: {},
  computed: {},

  data() {
    return {
      loginAlert: {
        tip: 2,
        msg: '请先登录'
      },
      bread: [
        {
          text: '首页',
          href: '/index'
        },
        {
          text: '用户登录'
        }
      ],
      form: {
        username: '',
        password: ''
      },
      loading: false
    };
  },

  mounted() {
    let tip = this.$route.query.tip;
    let msg = this.$route.query.msg;
    this.loginAlert.tip = tip == 1 ? 1 : 2;
    this.loginAlert.msg = msg;
  },

  activated() {
    //由401进入这里，要发个广播
    this.$root.eventHub.$emit('logout');
  },

  methods: {
    //表单提交
    onSubmit(evt) {
      evt.preventDefault();
      this.loading = true;
      axiosServer({
        url: urls.userLogin,
        type: 'post',
        params: this.form
      })
        .then(resp => {
          if (resp.data.code == 0) {
            let response = resp.data;
            const token = response.token;
            const expireTime = response.expire * 1000;
            Vue.ls.set('token', token, expireTime);
            Vue.ls.set('username', response.username, expireTime);
            Vue.ls.set('userId', response.userId, expireTime);

            let url = this.$route.query.redirectUrl;
            if (!url) {
              url = 'index';
            }
            this.$router.push({
              name: url
            });
            this.$root.eventHub.$emit('loginSuccess');
          } else {
            this.$bvToast.toast('登录失败 【' + resp.data.msg + '】', {
              title: '提示',
              toaster: 'b-toaster-top-center',
              appendToast: false,
              autoHideDelay: 2000,
              variant: 'danger'
            });
          }
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
@media (max-width: 575.99px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 576px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 768px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 50px;
  }
}

@media (min-width: 992px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 100px;
  }
}

@media (min-width: 1200px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 200px;
  }
}
</style>
